import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Toolbar from 'components/Layout/Toolbar';
import {
  ICriticalityMetrics,
  IHistoryMetrics,
  IScoreMetrics,
  IVentureStatusMetrics,
  statusesDashboard,
} from 'interfaces/dashboard';
import { statuses } from 'interfaces/file';
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import RxOp from 'rxjs-operators';
import dashboardService from 'services/dashboard';
import selectedVentureService from 'services/profile';
import ventureService from 'services/venture';

import CardGraphs from '../Component/Card';
import DocsActives from '../Graphs/Actives';
import DocumentCriticality from '../Graphs/Criticality';
import HistoricStatus from '../Graphs/HistoricStatus';
import ScoreVenture from '../Graphs/Score';
import DocumentStatus from '../Graphs/Status';
import EntityStatus from '../Graphs/Statuses';

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 700,
  },
  wrapperGrid: {
    [theme.breakpoints.up('md')]: {
      flexWrap: 'nowrap'
    }
  }
}));

const ViewVenture = () => {
  const history = useHistory();
  const [ventureMetrics, setVentureMetrics] = useState<IVentureStatusMetrics>();
  const [critacalityMetrics, setCritacalityMetrics] = useState<ICriticalityMetrics[]>();
  const [scoreMetrics, setScoreMetrics] = useState<IScoreMetrics>();
  const [historyMetrics, setHistoryMetrics] = useState<IHistoryMetrics>();
  const [ventureTitle, setVentureTitle] = useState<string>();
  const [idVenture, setIdVenture] = useState<number>();
  const classes = useStyles();

  useEffect(() => {
    selectedVentureService.getSelectedVenture().pipe(
      RxOp.logError(),
    ).subscribe((selectedVenture) => {
      if (selectedVenture) {
        setIdVenture(selectedVenture.id);
        setVentureTitle(selectedVenture.name);

        ventureService
          .getById(selectedVenture.id)
          .pipe(RxOp.logError())
          .subscribe(venture => {
            dashboardService.getStatus(venture.id).pipe(
              RxOp.logError(),
            ).subscribe(m => setVentureMetrics(m));

            dashboardService.getCriticality(venture.id).pipe(
              RxOp.logError(),
            ).subscribe(m => setCritacalityMetrics(m));

            dashboardService.getScore(venture.id).pipe(
              RxOp.logError(),
            ).subscribe(m => setScoreMetrics(m));

            dashboardService.getHistory(venture.id).pipe(
              RxOp.logError(),
            ).subscribe(m => setHistoryMetrics(m));
          });
      }
    });
  }, []);

  const { statusByEntity = null, statusByVenture = null } = ventureMetrics || {};
  const totalDocumentsVenture = statusByVenture ? statusByVenture.find(i => i.status === statusesDashboard.ACTIVE_DOCUMENTS).value : 0;

  const handleDashboardEntity = useCallback((entityId: number) => () => {
    history.push(`/documentation/dashboard/venture/${idVenture || 0}/entity/${entityId}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history, idVenture]);

  const findStatus = (status: statusesDashboard) => {
    return statusByVenture.find(i => status === i.status);
  };

  return (
    <>
      <Toolbar
        title="Dashboard"
        breadcrumbs={[
          { title: 'Dashboard', href: '/documentation/dashboard' },
          {
            title: ventureTitle,
            href: `/documentation/dashboard/venture/${idVenture}`
          }
        ]}
      />
      <Container>
        <Card>
          <CardHeader classes={{ title: classes.title }} title={ventureTitle} />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} lg={12} xl={12}>
                <Grid container className={classes.wrapperGrid}>
                  {statusByEntity && statusByEntity.map(entity => (
                    <Grid
                      item
                      key={`entity-status-graph-${entity.entityId}`}
                      xs={12} sm={6} lg={3} xl={6}
                    >
                      <EntityStatus
                        entityName={entity.entityName}
                        metrics={entity.data.filter(i => [...Object.keys(statuses), statusesDashboard.NOT_UPLOADED].includes(i.status))}
                        total={totalDocumentsVenture}
                        onClick={handleDashboardEntity(entity.entityId)}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
              <Grid item xs={12} lg={9} xl={10}>
                {statusByVenture && (
                  <CardGraphs bgcolor='rgba(226,221,235,0.5)'>
                    <Grid container>
                      {statusByVenture.filter(item => item.status !== statusesDashboard.ACTIVE_DOCUMENTS).map(ds => (
                        <Grid item key={`document-status-graph-${ds.status}`} xs={12} sm={6} lg={3}>
                          <DocumentStatus metrics={ds} total={totalDocumentsVenture} />
                        </Grid>
                      ))}
                    </Grid>
                  </CardGraphs>
                )}
              </Grid>
              <Grid item xs={12} lg={3} xl={2}>
                <Grid container>
                  {statusByVenture && findStatus(statusesDashboard.ACTIVE_DOCUMENTS) && (
                    <Grid item xs={12} sm={6} lg={12}>
                      <DocsActives
                        metrics={findStatus(statusesDashboard.ACTIVE_DOCUMENTS)}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} sm={6} lg={12}>
                    <DocumentCriticality metrics={critacalityMetrics || []} />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12} lg={9} xl={10}>
                    <HistoricStatus metrics={historyMetrics ? historyMetrics.statusByMonth : []} />
                  </Grid>
                  <Grid item xs={12} lg={3} xl={2}>
                    <ScoreVenture metrics={scoreMetrics || { max: 0, score: 0 }} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>
    </>
  );
};
export default ViewVenture;